{
  "PROFILE": {
    "SYSTEM_LOCATION_VALIDATOR": {
      "TITLE": "System Location",
      "SUCCESS_MESSAGE": "System location updated successfully."
    },
    "SYSTEM_PROTOCOL": {
      "LABEL": "System protocol",
      "DOWNLOAD": "Download",
      "TITLE": "Currently"
    }
  },
  "EDGE": {
    "CONFIG": {
      "APP": {
        "STATUS_INSTALLED": "Installed",
        "STATUS_AVAILABLE": "Available",
        "STATUS_INCOMPATIBLE": "Incompatible",
        "STATUS_FILTER": "Availability",
        "CATEGORY_FILTER": "App-Categories"
      }
    }
  }
}
